import React, { useState } from "react";

import { useForm } from "react-hook-form";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Fade, Grid, Modal, Backdrop } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";

import { addACrop, addASeason } from "../../redux/actions/cropPlanDevelopment";
import { useSelector } from "react-redux";

import {
  CropModalTextArea,
  CropPlanAddBtn,
  CropPlanButtonBox,
  CropPlanInput,
  CropPlanInputError,
  CropPlanInputText,
  CropPlanModal,
  CropPlanModalInner,
  CropPlanModalTitle,
} from "../../styles/cropPlan/CropPlanStyles";
import { CropCredentialsSchema } from "../validattion";
import { yupResolver } from "@hookform/resolvers/yup";

const useStyles = makeStyles({
  root: {
    // background: '#eff9f6',
    borderRadius: 3,
    cursor: "pointer",
    // border: 0,
    color: "rgba(1, 28, 20, 0.9)",
    // padding: '0 30px',
    // height: '20em',
    border: "1px solid rgba(1, 28, 20, 0.2)",
    // boxShadow: '0 3px 5px 2px rgba(5,5,5, .3)',
    "&::-webkit-scrollbar": {
      width: "6px",
      background: "red",
      color: "red",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    outline: "none",
  },
});

export const AddNewCrop = (props) => {
  const classes = useStyles();
  // --- get the access key of the user here ---
  const { access_token: access_key, user_details: user_details } = useSelector(
    (state) => state.authReducer
  );

  const [btnState, setBtnState] = useState({
    text: "Add Crop",
    isDisabled: false,
  });

  // handler to add a new crop
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
    resolver: yupResolver(CropCredentialsSchema),
  });
  const onSubmit = async (dataObject) => {
    setBtnState({ text: "Please wait!", isDisabled: true });
    const body = {
      ...dataObject,
      team: user_details?.owned_team?.id || user_details?.user_team,
    };

    let { isError } = await addACrop(access_key, body);

    if (isError) {
      toast.error(
        "Sorry, an error occurred and we could not add a new seasons",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setBtnState({ text: "Add Crop", isDisabled: false });
    } else {
      toast("Season successfully added", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      reset();
      props?.handleClose();
      setBtnState({ text: "Add Crop", isDisabled: false });
      // close the modal and refresh
      props?.setRenderData(13);
      props?.setOpen(false);
    }
  };
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props?.open}
        onClose={props?.handleClose}
        // closeAfterTransition
        // BackdropProps={{
        //   timeout: 100,
        // }}
        style={{ border: "none !important" }}
      >
        <Fade in={props?.open}>
          <CropPlanModal>
            <CropPlanModalInner>
              <Grid container spacing={1}>
                <Grid item lg={6} md={6} xs={6} sm={6}>
                  <CropPlanModalTitle>ADD NEW CROP</CropPlanModalTitle>
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={6}
                  xs={6}
                  sm={6}
                  style={{ float: "right" }}
                >
                  <CloseIcon
                    onClick={props?.handleClose}
                    style={{
                      float: "right",
                      cursor: "pointer",
                      color: "rgba(200,0,0,1)",
                    }}
                  />
                </Grid>
              </Grid>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                  <CropPlanInputText>Crop Name</CropPlanInputText>

                  <CropPlanInput
                    type="text"
                    placeholder="Crop Name"
                    defaultValue=""
                    {...register("name", { required: true })}
                  />
                  <CropPlanInputError>
                    {errors.name && errors.name.message}
                  </CropPlanInputError>
                </div>
                <div>
                  <CropPlanInputText>Crop Description</CropPlanInputText>

                  <CropModalTextArea
                    type="text"
                    placeholder="Crop Description"
                    defaultValue=""
                    {...register("description", { required: true })}
                  />
                  <CropPlanInputError>
                    {errors.description && errors.description.message}
                  </CropPlanInputError>
                </div>

                <CropPlanButtonBox style={{ marginTop: "0em" }}>
                  <Grid container spacing={3}>
                    <Grid item lg={2} md={2} xs={2} sm={6}></Grid>

                    <Grid item lg={2} md={2} xs={2} sm={6}></Grid>

                    <Grid item lg={4} md={4} xs={4} sm={6}>
                      {/* <CropPlanDelBtn onClick={props?.handleClose}>Cancel<CloseIcon /></CropPlanDelBtn> */}
                    </Grid>

                    <Grid item lg={4} md={4} xs={4} sm={6}>
                      <CropPlanAddBtn
                        type="submit"
                        disabled={btnState?.isDisabled}
                      >
                        {btnState?.text}
                      </CropPlanAddBtn>
                    </Grid>
                  </Grid>
                </CropPlanButtonBox>
              </form>
            </CropPlanModalInner>
          </CropPlanModal>
        </Fade>
      </Modal>
    </>
  );
};
